import {
    FETCH_INCIDENT_LIST,
    RESET_INCIDENT_LIST,
  } from "../../constants/action.constants";
  
  const initialState = {
    list: [],
    others: {
      total: 0,
      offset: 0,
      limit: 10,
    },
  };
  
  const incidentListReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_INCIDENT_LIST:
        return { list: action.payload, others: action.others };
      case RESET_INCIDENT_LIST:
        return initialState;
      default:
        return state;
    }
  };
  
  export default incidentListReducer;
  